module.exports = __webpack_public_path__ + "img/40.1e179cc9.png";